module.exports = __webpack_public_path__ + "img/logo.cb8f2224.svg";